import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import classnames from 'classnames'
import moment from 'moment'

import { formatPriceDecimals } from 'utils/format'

import styles from './setupform-summary.css'

const DATE_FORMAT = 'ddd D MMMM LT'

/* eslint-disable react/no-danger */
const SetupformVoucherSummary = ({ setupform, instanceGroups, venue, categoryName, imageUrl }) => (
  <div styleName="setupform-summary">
    <h1 styleName="title">Review your product</h1>
    <p>Review the product and voucher details that you have entered</p>
    <dl>
      <dt>Product name</dt><dd>{setupform.name}</dd>
      <dt>Description</dt><dd><span dangerouslySetInnerHTML={{ __html: setupform.description }} /></dd>
      <dt>Offer Description</dt><dd>{setupform.rawOfferText}</dd>
      <dt>Tagline</dt><dd>{setupform.tagline}</dd>
      <dt>Category</dt><dd>{categoryName}</dd>
      <dt>Image</dt><dd>
        {imageUrl && <img styleName="image-preview" alt="Product preview" src={imageUrl} />}
      </dd>
      <dt>Venue</dt><dd>{venue.name}, {venue.address1}, {venue.city}, {venue.postal_code}</dd>
      <dt>Redemption instructions</dt><dd><span dangerouslySetInnerHTML={{ __html: setupform.redeemInstructions}}/></dd>
      <dt>Terms &amp; conditions</dt><dd><span dangerouslySetInnerHTML={{ __html: setupform.terms}}/></dd>
      {/* <dt>Is this a shippable product?</dt><dd>{setup}</dd> */}
    </dl>
    <h2>Vouchers</h2>
    <table styleName="table">
      <thead>
        <tr>
          <th styleName="label">Voucher name</th>
          <th styleName="label cell-centered">Valid dates</th>
          <th styleName="label cell-centered">Sale dates</th>
          <th styleName="label">Qty</th>
          <th styleName="label">Price</th>
        </tr>
      </thead>
      <tbody styleName="table-body">
        {instanceGroups.map((instanceGroup, i) => (
          <tr key={instanceGroup.id} styleName={classnames('row', { 'row-alternate': i % 2 !== 0 })}>
            <td styleName="cell">{instanceGroup.instances[0].ticketType}</td>
            <td styleName="cell cell-centered">
              {moment(instanceGroup.instances[0].voucherValidFrom).local().format(DATE_FORMAT)}<br />
              to<br />
              {moment(instanceGroup.instances[0].voucherValidTo).local().format(DATE_FORMAT)}
            </td>
            <td styleName="cell cell-centered">
              {moment(instanceGroup.instances[0].onsaleTime).local().format(DATE_FORMAT)}<br />
              to<br />
              {moment(instanceGroup.instances[0].offsaleTime).local().format(DATE_FORMAT)}
            </td>
            <td styleName="cell">{instanceGroup.ticketCount}</td>
            <td styleName="cell">
              {instanceGroup.instances[0].initialPrice !== instanceGroup.instances[0].discountPrice &&
                <span>
                  <strike styleName="initial-price">
                    {formatPriceDecimals(instanceGroup.instances[0].initialPrice, setupform.currencyCode)}
                  </strike>/
                </span>
              }
              {formatPriceDecimals(instanceGroup.instances[0].discountPrice, setupform.currencyCode)}
              <br />
              <span styleName="commission">{+(instanceGroup.instances[0].commission)}% commission</span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)

SetupformVoucherSummary.propTypes = {
  setupform: PropTypes.object,
  instanceGroups: PropTypes.array,
  venue: PropTypes.object,
  categoryName: PropTypes.string,
  imageUrl: PropTypes.string,
}

export default CSSModules(SetupformVoucherSummary, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/setupform-summary/setupform-voucher-summary.js
 **/